module.exports = __webpack_public_path__ + "img/amperimetros.330f455c.jpg";